(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-final-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const mountRestock = () => {
    const source = document.getElementById('hw-restock-template');
    const target = document.querySelector('.hw-restock');
    if (!source || !target || target.dataset.hwRestockReady) return;
    target.replaceChildren(source.content.cloneNode(true));
    target.dataset.hwRestockReady = 'true';
  };

  const cleanCustomerReference = () => {
    const productRoot = document.querySelector('#MainContent[data-template^="product"]');
    const heading = productRoot?.querySelector('.product-details h1');
    if (!productRoot || !heading) return;
    const parts = heading.textContent.trim().split(/\s+/);
    const candidate = (parts.at(-1) || '').replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9.-]+$/g, '');
    if (!candidate || !/\d/.test(candidate)) return;
    productRoot.querySelectorAll('.hs-product-accordions__content p').forEach((row) => {
      const label = row.querySelector('strong');
      if (!label || !/model|reference|sku/i.test(label.textContent)) return;
      row.replaceChildren(label, document.createTextNode(` ${candidate}`));
    });
  };

  const init = () => { mountRestock(); cleanCustomerReference(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-klaviyo-integration"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.getElementById('hw-klaviyo-config');
  if (!configNode || configNode.dataset.hwReady === '1') return;
  configNode.dataset.hwReady = '1';

  let config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    return;
  }

  if (!config.companyId || !config.listId) return;

  const klaviyoScriptSelector = 'script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]';

  const loadKlaviyo = () => {
    if (window.klaviyo || document.querySelector(klaviyoScriptSelector)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(config.companyId);
    script.dataset.hwKlaviyo = '1';
    document.head.appendChild(script);
  };

  const privacyAllowsTracking = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return false;

    try {
      return privacy.analyticsProcessingAllowed() || privacy.marketingAllowed();
    } catch (error) {
      return false;
    }
  };

  const initPrivacyAwareTracking = () => {
    if (privacyAllowsTracking()) loadKlaviyo();

    document.addEventListener('visitorConsentCollected', () => {
      if (privacyAllowsTracking()) loadKlaviyo();
    });
  };

  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (!error) initPrivacyAwareTracking();
      }
    );
  } else {
    window.addEventListener('load', () => {
      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (!error) initPrivacyAwareTracking();
          }
        );
      }
    }, { once: true });
  }

  const subscribeToKlaviyo = async (email, signal) => {
    const response = await fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email
                  }
                }
              },
              custom_source: config.source
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: config.listId
                }
              }
            }
          }
        }),
        signal
      }
    );

    if (!response.ok && response.status !== 202) {
      throw new Error('Klaviyo subscription request failed');
    }
  };

  const bindNewsletter = () => {
    document.querySelectorAll('[data-hw-klaviyo-newsletter] form').forEach((form) => {
      if (form.dataset.hwKlaviyoBound === '1') return;
      form.dataset.hwKlaviyoBound = '1';

      form.addEventListener('submit', async (event) => {
        if (form.dataset.hwKlaviyoBypass === '1') return;

        const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
        if (!(emailInput instanceof HTMLInputElement) || !emailInput.validity.valid) return;

        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        if (button instanceof HTMLButtonElement) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }

        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 2500);

        try {
          await subscribeToKlaviyo(emailInput.value.trim(), controller.signal);
        } catch (error) {
        } finally {
          window.clearTimeout(timeout);
          form.dataset.hwKlaviyoBypass = '1';
          HTMLFormElement.prototype.submit.call(form);
        }
      });
    });
  };

  bindNewsletter();

  document.addEventListener('shopify:section:load', bindNewsletter);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-sitewide-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const initHwSitewideMotion = () => {
    const main = document.querySelector('#MainContent');
    if (!main || main.dataset.template?.startsWith('index') || main.dataset.template?.startsWith('collection')) return;
    if (main.dataset.hwSitewideMotionReady === '1') return;
    main.dataset.hwSitewideMotionReady = '1';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canObserve = 'IntersectionObserver' in window;

    const visibleNow = (element) => {
      const box = element.getBoundingClientRect();
      return box.bottom > 0 && box.top < (window.innerHeight || document.documentElement.clientHeight);
    };

    const revealObserver = canObserve && !reducedMotion ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          entry.target.classList.remove('hw-motion-visible');
          return;
        }
        if (entry.intersectionRatio >= 0.08) {
          entry.target.classList.add('hw-motion-visible');
        }
      });
    }, { threshold: [0, 0.08], rootMargin: '0px' }) : null;

    const makeVisible = (element) => {
      if (reducedMotion || !revealObserver) {
        element.classList.add('hw-motion-visible');
        return;
      }
      revealObserver.observe(element);
      if (visibleNow(element)) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => element.classList.add('hw-motion-visible'));
        });
      }
    };

    const applyReveal = (element, index = 0, card = false) => {
      if (!element || element.dataset.hwMotionRevealReady === '1') return;
      element.dataset.hwMotionRevealReady = '1';
      element.classList.add('hw-motion-reveal');
      element.style.setProperty('--hw-motion-delay', String(Math.min((index % 5) * 70, 280)) + 'ms');

      if (card) {
        element.style.setProperty('--hw-motion-x', index % 2 === 0 ? '-18px' : '18px');
        element.style.setProperty('--hw-motion-enter-y', '18px');
      }

      makeVisible(element);
    };

    const headingIsExcluded = (element) => Boolean(element.closest(
      'product-card,.product-card,.product-grid__item,.resource-card,.hw-card,.facets,.facets-block-wrapper,.theme-drawer,[role="dialog"],.sticky-add-to-cart'
    ));

    const prepareWriting = (element, delay = 0) => {
      if (!element || element.dataset.hwMotionWriteReady === '1') return;
      if (headingIsExcluded(element)) return;

      const text = element.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      element.dataset.hwMotionWriteReady = '1';

      if (element.children.length) {
        applyReveal(element, Math.floor(delay / 45), false);
        return;
      }

      element.classList.add('hw-motion-write');
      element.style.setProperty('--hw-write-delay', String(delay) + 'ms');
      element.setAttribute('aria-label', text);

      const fragment = document.createDocumentFragment();
      text.split(/\s+/).forEach((word, index, words) => {
        const span = document.createElement('span');
        span.className = 'hw-motion-word';
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--hw-word-index', String(index));
        span.textContent = word;
        fragment.appendChild(span);
        if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
      });

      element.replaceChildren(fragment);
      makeVisible(element);
    };

    const process = (root = main) => {
      if (!(root instanceof Element)) return;

      const headingSelector = '#MainContent h1,#MainContent h2,#MainContent h3';
      const headings = root.matches(headingSelector) ? [root] : [...root.querySelectorAll(headingSelector)];
      headings.forEach((heading, index) => prepareWriting(heading, Math.min(index * 45, 180)));

      const cardSelector = '.product-grid__item';
      const cards = root.matches(cardSelector) ? [root] : [...root.querySelectorAll(cardSelector)];
      cards.forEach((card, index) => applyReveal(card, index, true));

      if (main.dataset.template?.startsWith('product')) {
        const productDetails = main.querySelector('.product-details');
        const productContent = productDetails?.querySelector(':scope > .group-block > .group-block-content')
          || productDetails?.querySelector('.group-block-content');

        if (productContent) {
          const productUnits = [];

          [...productContent.children].forEach((element) => {
            if (!(element instanceof HTMLElement)) return;
            if (element.matches('.view-product-title,.visually-hidden,[hidden]')) return;
            if (element.closest('[role="dialog"],.theme-drawer,.sticky-add-to-cart')) return;
            if (element.querySelector('h1.hw-motion-write,h2.hw-motion-write,h3.hw-motion-write')) return;

            const accordionRows = [...element.querySelectorAll('.hs-product-accordions > details')];
            if (accordionRows.length) {
              productUnits.push(...accordionRows);
              return;
            }

            productUnits.push(element);
          });

          productUnits.forEach((element, index) => {
            applyReveal(element, index, false);

            if (element instanceof HTMLDetailsElement && element.dataset.hwMotionToggleReady !== '1') {
              element.dataset.hwMotionToggleReady = '1';
              element.addEventListener('toggle', () => {
                if (!element.open || reducedMotion || !visibleNow(element)) return;
                element.classList.remove('hw-motion-visible');
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => element.classList.add('hw-motion-visible'));
                });
              });
            }
          });
        }
      }

      const revealSelector = [
        '.facets-toggle',
        '.facets-block-wrapper',
        '.hw-page aside',
        '.hw-page article > p',
        '.hw-page article > ul',
        '.hw-page article > ol',
        '.shopify-policy__body > p',
        '.shopify-policy__body > ul',
        '.shopify-policy__body > ol'
      ].join(',');
      const reveals = root.matches(revealSelector) ? [root] : [...root.querySelectorAll(revealSelector)];
      reveals.forEach((element, index) => applyReveal(element, index, false));

      headings.forEach((heading) => {
        const section = heading.closest('.shopify-section');
        if (!section) return;
        [...section.querySelectorAll('p')]
          .filter((paragraph) => !paragraph.closest('product-card,.product-card,.product-grid__item,.resource-card,.hw-card,.facets'))
          .slice(0,3)
          .forEach((paragraph,index) => applyReveal(paragraph,index,false));
      });
    };

    process(main);

    let refreshQueued = false;
    const queueFullRefresh = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        process(main);
      });
    };

    const dynamicObserver = new MutationObserver((records) => {
      let shouldRefresh = false;

      records.forEach((record) => {
        if (record.type !== 'childList') return;
        if (record.addedNodes.length || record.removedNodes.length) shouldRefresh = true;
      });

      if (shouldRefresh) queueFullRefresh();
    });
    dynamicObserver.observe(main, { childList:true, subtree:true });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element && main.contains(event.target)) queueFullRefresh();
    });

    const replayVisibleMotion = () => {
      process(main);
      const visibleElements = [...main.querySelectorAll('.hw-motion-write,.hw-motion-reveal')]
        .filter((element) => visibleNow(element));

      visibleElements.forEach((element) => element.classList.remove('hw-motion-visible'));
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          visibleElements.forEach((element) => element.classList.add('hw-motion-visible'));
        });
      });
    };

    window.addEventListener('pageshow', replayVisibleMotion);
    document.addEventListener('pagereveal', replayVisibleMotion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHwSitewideMotion, { once:true });
  } else {
    initHwSitewideMotion();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
